<template>
  <div class="invite-page" v-if="pageShow">
    <div class="err-tip-img">
      <img :src="courseEmpty" />
    </div>
    <div class="err-tip-title">
      <span>加入失败</span>
    </div>
    <div class="err-tip-desc" v-if="errMsg">
      <span>{{ errMsg }}</span>
    </div>
    <div class="err-tip-desc" v-else>
      <div>分享链接已过期</div>
      <div>请联系该企业管理员重新生成邀请链接后进入。</div>
    </div>
  </div>
</template>

<script>
import { services } from '@/service';
import courseEmpty from '@/assets/img/courseEmpty.png';

export default {
  data() {
    return {
      pageShow: false,
      courseEmpty,
      errMsg: ''
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.joinHandle();
    } else {
      this.errMsg = '请联系课题所有者重新生成邀请链接。';
      this.pageShow = true;
    }
  },
  methods: {
    async joinHandle() {
      try {
        const result = await services.courseware.joinCourseByLink(this.$route.query.id);
        this.$message.success(`成功加入课题`);
        if (result && result.data) {
          this.$router.replace({
            path: '/research-dashboard',
            query: {
              courseware_id: result.data
            }
          });
        } else {
          this.$router.replace({ name: 'home' });
        }
      } catch (err) {
        this.pageShow = true;
        this.errMsg = err.message;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.invite-page {
  text-align: center;
  width: 420px;
  margin: 200px auto 0;

  .err-tip-img {
    & > img {
      width: 60px;
      height: 56px;
    }
  }

  .err-tip-title {
    color: #172237;
    font-size: 16px;
    line-height: 22px;
    margin-top: 8px;
  }

  .err-tip-desc {
    color: #9599a5;
    font-size: 14px;
    line-height: 22px;
    margin-top: 9px;
  }
}
</style>
